import cn from "classnames";
import React, { FunctionComponent } from "react";

import { PropTypesOf } from "coral-framework/types";
import CLASSES from "coral-stream/classes";
import { Flex } from "coral-ui/components/v2";
import { Button } from "coral-ui/components/v3";

import styles from "./PianoButton.css";

interface Props {
  onClick: PropTypesOf<typeof Button>["onClick"];
  children: React.ReactNode;
}

const PianoButton: FunctionComponent<Props> = (props) => (
  <Button
    className={cn(CLASSES.login.pianoButton, styles.button)}
    variant="filled"
    color="none"
    fontSize="small"
    paddingSize="small"
    upperCase
    fullWidth
    onClick={props.onClick}
  >
    <Flex alignItems="center" justifyContent="center">
      <span>{props.children}</span>
    </Flex>
  </Button>
);

export default PianoButton;
